import { Component, Input } from '@angular/core';

@Component({
  selector: 'light-badge',
  templateUrl: './light-badge.component.html',
  standalone: false,
})
export class LightBadgeComponent {
  @Input() label: string;
  @Input() tooltip: string;
}
